import { setSubject } from '@/utils/subject';
import useConfigStore, { ApiPlatformValue } from './useConfigStore';
import useThemeStore from './useThemeStore';

function isIpePlatform() {
  if (process.env.PLATFORM === 'ipe') {
    return true;
  }

  return (
    window.location.hostname.endsWith('ipe.courseware.bj33smarter.com') ||
    window.location.hostname.endsWith('ipe.courseware.staging.bj33smarter.com')
  );
}

function init() {
  if (isIpePlatform()) {
    const platformTitle = '思政教学辅助系统';

    useConfigStore.setState({
      hasLoginSubjectSelector: false,
      platformName: platformTitle,
      apiPlatformValue: ApiPlatformValue.Ipe,
    });

    document.title = platformTitle;

    useThemeStore.setState({
      antdThemeColor: 'rgba(253, 60, 55, 1)',
      hasMainLayoutHeaderBg: true,
      mainLayoutHeaderTextColor: '#fff',
      mainLayoutHeaderUserSpaceIcon: 1,
      mainLayoutHeaderUserSpaceBg: 'rgba(255, 255, 255, 0.2)',
      mainLayoutHeaderUserSpaceSpanBg: 'rgba(177, 138, 100, 1)',

      stepBlockBgColor: 'rgba(252, 177, 111, 0.1)',
      stepBlockTextColor: 'rgba(247, 136, 65, 1)',
      sidePanelLinkColor: 'rgba(192, 25, 32, 1)',

      fileCardBgColor:
        'linear-gradient(90.00deg, rgba(255, 255, 255, 1) 50%,rgba(255, 251.05, 245.51, 1) 100%)',
      fileCardBorder: '1px solid rgba(0, 0, 0, 0.08)',
      fileCardBorderActiveColor: 'rgba(194, 137, 58, 1)',
      fileCardBgPng: 1,
      fileCardSmartGeneratePng: 1,

      chatSendBtnBgColor: 'rgba(177, 138, 100, 1);',
      chatSendBtnBgHoverColor: 'rgba(159, 124, 90, 1)',

      chatSenderBorder: '0.8px solid rgba(199, 199, 199, 1)',
      chatSenderBgColor: undefined,
      chatBubbleLoadingSvg: 1,

      thinkDeeplyBtnColor: 'rgba(192, 25, 32, 1)',
      thinkDeeplyBtnBorder: '1px solid rgba(192, 25, 32, 0.3)',
      thinkDeeplyBtnBgColor: 'rgba(192, 25, 32, 0.05)',
      thinkDeeplyBtnHoverColor: 'rgba(192, 25, 32, 1)',
      thinkDeeplyBtnBgHoverColor: 'rgba(192, 25, 32, 0.1)',
      thinkDeeplyActiveIcon: 1,
      hasMainLayoutSiderBg: true,
      mainLayoutSiderContentColor: 'rgba(192, 25, 32, 1)',
      mainLayoutSiderContentBg: 'rgba(192, 25, 32, 0.12)',
      mainLayoutSiderContentBorder: 'rgba(192, 25, 32, 0.25)',
      mainLayoutSiderContentIcon: 1,
      mainLayoutSiderContentSelectedBg: 'rgba(247, 136, 65, 0.12)',
      mainLayoutSiderContentSelectedColor: 'rgba(192, 25, 32, 1)',

      mainLayoutSiderHistorySessionIcon: 1,
      mainLayoutSiderHistorySessionIconBg: 'rgba(247, 136, 65, 0.12)',
      mainLayoutSiderHistorySessionCurrent: 'rgba(247, 136, 65, 0.12)',
      mainLayoutSiderHistorySessionText: 'rgba(37, 40, 43, 1)',

      teachingPlanFormLessonIcon: 1,
      teachingPlanFormUnitIcon: 1,
      agentFormHeaderCardBorderColor: 'rgba(192, 25, 32, 1)',
      agentFormHeaderCardBackgroundColor: 'rgba(192, 25, 32, 0.08)',
      agentFormBodySwitchColor: 'rgba(212, 176, 121, 1), rgba(194, 137, 58, 1)',
      agentFormBodyRadioCheckboxColor: 'rgba(194, 137, 58, 0.65)',
      agentFormActionDownBorderColor: '#C2893A, #C6A46C',
      agentFormActionDownColor: 'rgba(194, 137, 58, 1)',
      agentFormActionDownHoverColor: 'rgba(249, 243, 236, 1)',
      teachingPlanFormActionButtonBackgroundColor: 'rgba(253, 60, 55, 1)',
      teachingPlanFormActionButtonHoverColor: 'rgba(255, 105, 100, 1)',

      commonTabGroupColor: 'rgba(192, 25, 32, 1)',
      coursewareCreateButtonBgColor: 'rgba(253, 60, 55, 1)',
      coursewareCreateButtonBgHoverColor: 'rgba(255, 105, 100, 1)',
      coursewareGotoCommunityImg: 1,

      coursewareEmptyActionTextColor: 'rgba(192, 25, 32, 1)',
      coursewareEmptyBgColor: '#F9F8F6',
      coursewareEmptyCollaboratedImg: 1,
      coursewareEmptyUsedImg: 1,

      dropDownMeunColor: '#6E7880',

      coursewarePublishButtonBgColor: 'rgba(253, 60, 55, 1)',
      coursewarePublishButtonBgHoverColor: 'rgba(255, 105, 100, 1)',

      coursewareDetailBgColor: '#FFFFFF',
      coursewareDetailBorder: '6px solid rgba(192, 25, 32, 0.1)',
      coursewareScenesStepsBgColor: 'rgba(255, 223, 222, 1)',

      coursewareDetailCenterModuleIntroCardBgColor: 'rgba(251, 246, 240, 1)',

      coursewareInfoTabsActiveColor: 'rgba(171, 49, 56, 1)',

      moduleIntroUnitGuideDividerBgColor: 'rgba(192, 25, 32, 1)',
      moduleIntroModelDividerBgColor: 'rgba(192, 25, 32, 1)',

      filterBorderColor: 'rgba(199, 199, 199, 0.4)',
      filterHoverBodrderColor: 'rgba(253, 60, 55, 1)',
      filterActiveBorderColor: 'rgba(253, 60, 55, 1)',

      resourceCreationUploadBorder: '1px dashed rgba(255, 89, 89, 0.4)',
      resourceCreationUploadHoverBorder: '1px dashed rgba(253, 60, 55, 1)',
      resourceCreationUploadBgColor: 'rgba(255, 89, 89, 0.06)',
      resourceCreationUploadHoverBgColor: 'rgba(255, 89, 89, 0.12)',
      resourceCreationUploadDragIconColor: 'rgba(253, 60, 55, 1)',
      resourceCreationUploadProgressStartColor: 'rgba(212,176,121,1)',
      resourceCreationUploadProgressEndColor: 'rgba(194, 137, 58, 1)',
      resourceCreationBtnBgColor: 'rgba(253, 60, 55, 1)',
      resourceCreatButtonBgColor: 'rgba(253, 60, 55, 1)',
      resourceCreatButtonHoverBgColor: 'rgba(255, 105, 100, 1)',

      emptyWithCreateQuickPanBgColor: '#F9F8F6',
      emptyQualityImg: 1,
      emptyUnitKnowledgePointImg: 1,

      loginSignInBackground: 2,
      loginSignInSlogan: false,
      loginSignInFormTitle: '思政教学辅助系统',
      hasLoginSignInFormLogo: false,
      loginSignInSubjectSelect: false,
      loginSignInCaptchaButtonColor: '#c01920',
      loginSignInAgreement: 'ipe',
      loginSignInAgreementCheckboxColor: '#c01920',
      loginSignInFormBackground: 1,

      hiddenLogo: true,

      settingsLeftNavPersonalIcon: 1,
      settingsLeftNavSchoolIcon: 1,
      settingsLeftNavAccountIcon: 1,
      settingsLeftNavAboutIcon: 1,
      settingsAboutTextColor: 'rgba(192, 25, 32, 1)',
      settingsAboutTextHoverColor: 'rgba(154, 20, 26, 1)',
      settingsPersonalAvatarBg: 'rgba(177, 138, 100, 1)',
      settingsPersonalButtonBg: 'rgba(253, 60, 55, 1)',
      settingsAboutTitle: '思政教学辅助系统',
      settingsContractItemTitle: '思政教学辅助系统用户协议',
      settingsAboutAgreement: 'ipe',

      moduleTabsBgColor: '#FFFFFF',
      moduleTabsHoverBgColor: 'rgba(110, 120, 128, 0.08)',
      moduleTabsBorder: '1px solid rgba(0, 0, 0, 0.1)',
      moduleTabsActiveColor: 'rgba(192, 25, 32, 0.1)',
      moduleTabsUnitGuideColor: 'rgba(209, 129, 18, 0.12)',
      moduleTabsModuleIcon: 2,

      playerBackgroundColor: 'rgba(192, 25, 32, 0.1)',
      playerIntroBoxColorBar: 2,
      playerGuideButtonIcon: 2,
      playerDigitalHumanBoxBg: 2,
      playerColourStyle: 2,
      playerEmptyImage: 2,
      unitGuideLayoutstyle: 2,

      pageLoadingSuit: 2,

      hasChatWelcomeTitleBg: true,
      chatToolListConfig: 1,
      chatToolListItemBg: 'rgba(249, 235, 232, 1)',
      chatToolListItemTagBg:
        'linear-gradient( 90deg, rgba(255, 89, 89, 1), rgba(241, 127, 65, 1) 100% )',
      chatToolListItemTextColor: 'rgba(255, 255, 255, 1)',

      notFoundIcon: 1,

      aiPptChatHistoryFavoritesIcon: 1,
      aiPptChatHeaderFavoritesIcon: 1,
      aiPptChatLeftButtonIcon: 1,
      aiPptChatLeftButtonBg: 'rgba(194, 137, 58, 0.14)',
      aiPptChatLeftButtonColor: 'rgba(76, 49, 22, 1)',
      aiPptChatLeftButtonBorder: 'rgba(194, 137, 58, 0.14)',
      aiPptChatSendButtonIcon: 1,
      aiPptChatDeepCreationButtonColor: 'rgba(192, 25, 32, 1)',
      aiPptChatDeepCreationButtonBg: '#f2eaeb',
      aiPptChatDeepCreationButtonHoverBg: '#eedfdf',
      aiPptChatDeepCreationButtonIcon: 1,
      aiPptChatGenerateButtonIcon: 1,
      aiPptChatGenerateButtonHoverColor: 'rgba(192, 25, 32, 1)',
      hasAiPptChatDeepCreationDialogDescribe: false,

      resourceUnitGuideIcon: 1,
      resourceUnitGuideBg: 'rgba(253, 60, 55, 0.08)',
      resourceCommunityTextColor: 'rgba(192, 25, 32, 1)',
      resourceQuickCreateImage: 1,
      resourceQuickUploadImage: 1,
      resourceEmptyScaffoldImage: 1,
      resourceEmptyTeachingImage: 1,

      pptAddedButtonsBgColor: 'rgba(253, 60, 55, 1)',
      pptToolbarAddedBgColor:
        'linear-gradient(90.00deg, rgba(212, 176, 121, 1),rgba(194, 137, 58, 1) 100%)',

      resourceEmptyCoursewareImage: 1,

      scaffoldingBgColors: 'rgba(255, 223, 222, 1)',
      scenesStepTabsStyle: 2,
      sceneStepTabsIcon: 2,

      communityCoursewareImage: 1,
      communityCoursewareBg: 'rgba(253, 60, 55, 0.08)',

      courseWareInfiniteCardButtonColor: 'rgba(253, 60, 55, 1)',
      courseWareInfiniteCardButtonColorHover: 'rgba(255, 105, 100, 1)',
      courseWareInfiniteCardButtonIcon: 1,
      courseWareInfiniteCardUseButtonColor: 'rgba(255, 232, 231, 1)',
      courseWareInfiniteCardUseButtonColorHover: 'rgba(255, 237, 236, 1)',
      courseWareInfiniteCardUseButtonIcon: 1,
      courseWareInfiniteCardUseButtonBorder: 'rgba(253, 60, 55, 0.4)',
      courseWareInfiniteCardUseButtonFontColor: 'rgba(253, 60, 55, 1)',

      learningSpaceDocumentBg: 'rgba(253, 60, 55, 0.08);',
      learningSpaceDocumentImage: 1,

      agentMaterialBgImage: 1,
      agentMaterialTextColor: '#6E7880',
    });

    setSubject({
      id: '100001',
      name: '高校思想政治理论课',
    });
  }
}

init();
